<div *ngIf="formGroup">
    <form [formGroup]="formGroup">
        <div class="row mt-3">
            <div class="col-12">
                <div class="col-12 px-0 filter-item">
                    <lib-text-box *ngIf="allowAddressNameField && formGroup?.controls?.name" 
                        [permission]="this.permission"
                        [control]="formGroup.controls.name" 
                        [labelBlock]="true" 
                        [idName]="'name'"
                        [label]="'Name:' | translate"
                        [maxLength]="40">
                    </lib-text-box>
                </div>
                <div class="col-12 px-0 filter-item">
                    <lib-text-box *ngIf="formGroup?.controls?.addressLine1" 
                        [permission]="this.permission"
                        [control]="formGroup.controls.addressLine1" 
                        [labelBlock]="true" 
                        [idName]="'include-component-parts'"
                        [label]="'Address Line 1:' | translate"
                        [maxLength]="40">
                    </lib-text-box>
                </div>
                <div class="col-12 px-0 filter-item">
                    <lib-text-box *ngIf="formGroup?.controls?.addressLine2" 
                        [permission]="this.permission"
                        [control]="formGroup.controls.addressLine2" 
                        [labelBlock]="true" 
                        [idName]="'include-component-parts'"
                        [label]="'Address Line 2:' | translate"
                        [maxLength]="40">
                    </lib-text-box>
                </div>
                <div class="col-12 col-lg-8 px-0 filter-item">
                    <lib-text-box *ngIf="formGroup.controls?.townCity" 
                        [permission]="this.permission"
                        [control]="formGroup.controls.townCity" 
                        [labelBlock]="true" 
                        [idName]="'city'" 
                        [label]="'Town / City:' | translate"
                        [maxLength]="40">
                    </lib-text-box>
                </div>
                <div class="col-12 col-lg-8 px-0 filter-item">
                    <lib-text-box *ngIf="formGroup.controls?.countyState" 
                        [permission]="this.permission"
                        [control]="formGroup.controls.countyState" 
                        [labelBlock]="true" 
                        [idName]="'state'" 
                        [label]="'County / State:' | translate"
                        [maxLength]="80">
                    </lib-text-box>
                </div>
                <div class="col-12 col-lg-8 px-0 filter-item">
                    <lib-text-box *ngIf="formGroup.controls?.postalCode" 
                        [permission]="this.permission"
                        [control]="formGroup.controls.postalCode" 
                        [labelBlock]="true" 
                        [idName]="'postcode'" 
                        [label]="'Postcode:' | translate"
                        [maxLength]="15">
                    </lib-text-box>
                </div>
                <div class="col-12 col-lg-8 px-0 filter-item">
                    <phone-number-input *ngIf="formGroup.controls?.contactNumber" [numberObj]="{number: formGroup.controls.contactNumber.value}" 
                        [isRequiredField]="contactNumberRequired || (contactNumberVerified != undefined ? true : false)" [size]="'md'" (numberUpdated)="numberUpdated($event, formGroup.controls.contactNumber)"
                        (numberVerifiedEmit)="checkIsVerified($event, 'contactNumber')" [label]="'Contact Number:' | translate" [defaultCountryCode]="defaultCountry?.code ? defaultCountry?.code : undefined" 
                        [parentFormSubmitted]="parentFormSubmitted">
                    </phone-number-input>
                </div>
            </div>
        </div>
    </form>
</div>
